import { render, staticRenderFns } from "./FirstLoginTwoFactorAuth.vue?vue&type=template&id=3bacf52d&scoped=true"
import script from "./FirstLoginTwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./FirstLoginTwoFactorAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bacf52d",
  null
  
)

export default component.exports